import { paginatedGql, toStandardResult } from "../util/graphql.js";
import { useMutation, useQuery } from "@apollo/react-hooks";

import gql from "graphql-tag";

const myProshopVoucherSchema = `
  id
  voucherCode
  companyCode
  amount
  expirationDate
  validated
  usedAt
`;

export function useMyProshopVouchersUsable() {
  const result = useQuery(
    gql`
      query GET_MYPROSHOP_VOUCHERS_USABLE {
        private {
          myProshopVouchers {
            list: fetchUsableVouchers {
              amount
              expirationDate
              quantity
            }
          }
        }
      }
    `,
    {
      fetchPolicy: "cache-and-network",
    },
  );

  return toStandardResult(result, "private.myProshopVouchers.list");
}

export function useMyProshopVouchersOrder() {
  const [mutation, result] = useMutation(
    gql`
      mutation MYPROSHOP_VOUCHERS_ORDER($data: MyProshopVouchersOrderPrivateInput!) {
        private {
          myProshopVouchers {
            success: orderVouchers(data: $data) {
              ${myProshopVoucherSchema}
            }
          }
        }
      }
    `,
  );
  return [
    (amounts) => mutation({ variables: { data: { amounts } } }),
    ...toStandardResult(result, "private.myProshopVouchers.success"),
  ];
}

export function useMyProshopVouchers(pagination) {
  const result = useQuery(
    gql`
      query GET_MYPROSHOP_VOUCHERS($pagination: PaginationInput) {
        private {
          myProshopVouchers {
             list: findVouchers(
              pagination: $pagination
            ) {
              ${paginatedGql(myProshopVoucherSchema)}
            }
          }
        }
      }
    `,
    {
      fetchPolicy: "cache-and-network",
      variables: {
        pagination,
      },
    },
  );

  return toStandardResult(result, "private.myProshopVouchers.list");
}
